import { TypedMoney } from "@commercetools/platform-sdk";
import { ProductAttribute } from "@wttb/product-configurator";

import { PriceItem } from "./quantity-table";

export const MAX_QUANTITY = 100000;
export const MIN_QUANTITY = 1;
export const DEFAULT_LIST_LENGTH = 6;
export const MAX_LIST_LENGTH = 10;

export const getPricesDifference = (currentPrice?: TypedMoney, priceForCompare?: TypedMoney) => {
  if (!currentPrice || !priceForCompare) return undefined;

  const centDifference = priceForCompare.centAmount - currentPrice.centAmount;
  if (centDifference <= 0) return undefined;

  return { ...currentPrice, centAmount: centDifference };
};

export const validateQuantity = (q: number, max: number, min: number) => {
  if (isNaN(q)) return false;
  if (q <= 0 || q > max || q < min) return false;
  return true;
};

export const prepareCollapsedPricesForView = (
  attribute: ProductAttribute,
  prices: PriceItem[],
  quantity: number,
) => {
  if (!attribute.alwaysVisibleValueIds.length) return [];
  // Get the default value
  const selectedValue = prices.find((price) => quantity === price.value);

  // We should match `attribute.alwaysVisibleValueIds` with Attribute prices and prices value
  // prices values are already sorted on server
  return prices.filter(
    (p: PriceItem) => attribute.alwaysVisibleValueIds.includes(p.id) || p.id === selectedValue?.id,
  );
};
